
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      countdownOptions: {},
    };
  },
  computed: {
    ...mapGetters(['$bus']),
  },
  beforeMount() {
    // 时间 - 设置倒计时
    this.countdownOptions = {};
    this.$bus.$on('rocket:timer:setCountdown', this.setCountdown);
  },
  beforeDestroy() {
    this.clearTimer();
  },
  methods: {
    handleVisible(isShow) {
      if (isShow) {
        let timerList = Object.keys(this.countdownOptions);
        if (timerList && timerList.length != 0) {
          timerList.forEach((name) => {
            this.setCountdown(
              name,
              this.countdownOptions[name].startTime,
              this.countdownOptions[name].endTime,
              this.countdownOptions[name].interval
            );
          });
        }
      } else {
        this.clearTimer();
      }
    },
    clearTimer(name) {
      if (name) {
        // 清除指定
        this.countdownOptions[name].timer &&
          clearInterval(this.countdownOptions[name].timer);
      } else {
        // 清除所有
        let timerList = Object.keys(this.countdownOptions);
        if (timerList && timerList.length != 0) {
          timerList.forEach((name) => {
            this.countdownOptions[name].timer &&
              clearInterval(this.countdownOptions[name].timer);
          });
        }
      }
    },
    formatNum(n) {
      return n < 10 ? '0' + n : '' + n;
    },
    timeToData(diffTime, name) {
      if (diffTime <= 0) {
        diffTime = 0;
        this.clearTimer(name);
      }

      let second = Math.floor(diffTime % 60); //计算秒
      let minute = Math.floor((diffTime / 60) % 60); //计算分
      let hour = Math.floor((diffTime / 3600) % 24); //计算小时
      let day = Math.floor(diffTime / 3600 / 24); //计算天

      return {
        day: this.formatNum(day),
        hour: this.formatNum(hour),
        minute: this.formatNum(minute),
        second: this.formatNum(second),
      };
    },
    setCountdown(name, _startTime, _endTime, interval) {
      // 设置缓存，当页面聚焦显示时，重新执行
      this.countdownOptions[name] = {
        ...this.countdownOptions[name],
        ...{
          startTime: _startTime,
          endTime: _endTime,
          interval: interval < 1000 ? 1000 : interval,
        },
      };

      if (!_startTime || !_endTime || !interval) return;

      let startTime = 0,
        endTime = 0;
      let newStart = new Date(_startTime),
        newEnd = new Date(_endTime);

      // 格式化到秒
      if (
        !newStart ||
        newStart == 'Invalid Date' ||
        !newEnd ||
        newEnd == 'Invalid Date'
      ) {
        console.error('时间格式错误');
        return;
      } else {
        let originStart = newStart.getTime();
        let originEnd = newEnd.getTime();

        if (originStart.toString().length == 13) {
          startTime = Math.round(originStart / 1000);
        }
        if (originEnd.toString().length == 13) {
          endTime = Math.round(originEnd / 1000);
        }
      }

      if (startTime >= endTime) {
        // 结束时间早于开始时间
        return { day: '00', hour: '00', minute: '00', second: '00' };
      } else {
        let initTime = Math.round(new Date().getTime() / 1000);
        if (initTime >= startTime) {
          // 计时开始前，默认给一次结果
          let subTime = Math.round(new Date().getTime() / 1000);
          let diffTime = endTime - subTime;
          let timeLeft = this.timeToData(diffTime, name);
          this.$bus.$emit(
            'rocket:timer:countdown-listen:' + name,
            timeLeft,
            timeLeft.day,
            timeLeft.hour,
            timeLeft.minute,
            timeLeft.second
          );

          // 开始倒计时
          this.clearTimer(name);
          this.countdownOptions[name].timer = setInterval(() => {
            let subTime = Math.round(new Date().getTime() / 1000);
            let diffTime = endTime - subTime;
            let timeLeft = this.timeToData(diffTime, name);
            this.$bus.$emit(
              'rocket:timer:countdown-listen:' + name,
              timeLeft,
              timeLeft.day,
              timeLeft.hour,
              timeLeft.minute,
              timeLeft.second
            );
          }, interval);
        } else {
          // 倒计时未开始
          let diffTime = endTime - startTime;
          return this.timeToData(diffTime, name);
        }
      }
    },
  },
};
